import React, { useState, useEffect } from "react";
import "./buycourse.css";
import { motion } from "framer-motion"

const Buycourse = () => {

    const [showPopup, setShowPopup] = useState(false);
    const [showOtpPopup, setShowOtpPopup] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        password: "",
        confirmPassword: "",
        otp: "",
    });

    const handleEnrollClick = () => {
        setShowPopup(true);
    };

    const closePopup = () => {
        setShowPopup(false);
    }

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        const { name, email, phone, password, confirmPassword } = formData;
        if (password !== confirmPassword) {
            alert("Passwords do not match!");
            return;
        }
        try {
            const res = await fetch("http://localhost:3001/api/send-otp", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ name, email, phone, password }),
            });
            const data = await res.json();

            if (res.ok) {
                alert("OTP sent to your email");
                setShowOtpPopup(true);
            } else {
                alert(data.error || "Signup failed. Try again.");
            }
        } catch (err) {
            console.error("Signup error:", err);
            alert("Error connecting to server.");
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch("http://localhost:3001/api/verify-otp", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: formData.email, otp: formData.otp }),
            });
            const data = await res.json();

            if (res.ok) {
                alert("OTP verified successfully!");
                setOtpVerified(true);
                setShowOtpPopup(false);
            } else {
                alert(data.error || "Invalid OTP.");
            }
        } catch (err) {
            console.error("OTP verify error:", err);
            alert("Error verifying OTP.");
        }
    };

    const handlePayment = async (e) => {
        e.preventDefault();

        const { name, email, phone } = formData;
        if (!otpVerified) {
            alert("Please verify your OTP before proceeding to payment.");
            return;
        }

        try {
            const res = await fetch("http://localhost:3001/api/create-checkout-session", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ name, email, phone }),
            });

            const data = await res.json();

            if (data.url) {
                window.location.href = data.url;
            } else {
                alert("Payment session failed.");
            }
        } catch (error) {
            console.error("Error creating checkout session:", error);
            alert("Error connecting to payment server.");
        }
    };


    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        if (query.get("success") === "true") {
            alert("🎉 You have successfully enrolled in the course!");
            window.history.replaceState({}, document.title, "/course");
        }
        document.body.style.overflow = showPopup || showOtpPopup ? "hidden" : "auto";
        return () => (document.body.style.overflow = "auto");
    }, [showPopup, showOtpPopup]);;

    return (
        <>
            <div className="course-page">
                <section className={`course-hero ${showPopup ? "blurred" : ""}`}>
                    <motion.h1
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        Learn to Scale Your Business with <span>Born2Scale</span>
                    </motion.h1>
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.6 }}
                    >
                        Master the art of marketing, branding, and digital growth — guided by real industry experience.
                    </motion.p>
                    <motion.div
                        className="video-container"
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.6 }}
                    >
                        <iframe
                            src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
                            title="Born2Scale Course Intro"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </motion.div>
                </section>
                <section className={`course-info ${showPopup ? "blurred" : ""}`}>
                    <h1>What You’ll Learn</h1>
                    <ul>
                        <li>✅ Building a strong online presence with websites & branding</li>
                        <li>✅ Digital marketing strategies that actually convert</li>
                        <li>✅ Social media growth & content that sells</li>
                        <li>✅ Scaling your business using data and automation</li>
                    </ul>

                    <p>
                        Whether you're an entrepreneur, freelancer, or student — this course helps you
                        transform your ideas into results with real-world strategies Born2Scale uses
                        every day for our clients.
                    </p>

                    <button className="buy-btn" onClick={handleEnrollClick}>Enroll Now</button>
                </section>

                {/* Signup Popup */}
                {showPopup && (
                    <div className="popup-overlay">
                        <motion.div className="popup" initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }}>
                            <h2>Sign Up to Enroll</h2>
                            <form className="popup-form" onSubmit={handleSignup}>
                                <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
                                <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
                                <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
                                <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
                                <input type="password" name="confirmPassword" placeholder="Confirm Password" value={formData.confirmPassword} onChange={handleChange} required />
                                <button type="submit">Verify Email (Send OTP)</button>
                            </form>
                            <span className="close-btn" onClick={closePopup}>✖</span>
                        </motion.div>
                    </div>
                )}

                {/* OTP Verification Popup */}
                {showOtpPopup && (
                    <div className="popup-overlay">
                        <motion.div className="popup" initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }}>
                            <h2>Verify OTP</h2>
                            <form className="popup-form" onSubmit={handleVerifyOtp}>
                                <input type="text" name="otp" placeholder="Enter OTP" value={formData.otp} onChange={handleChange} required />
                                <button type="submit">Verify OTP</button>
                            </form>
                            <span className="close-btn" onClick={closePopup}>✖</span>
                        </motion.div>
                    </div>
                )}

                {/* Proceed to Payment (visible only if OTP verified) */}
                {otpVerified && (
                    <div className="payment-section">
                        <motion.div className="payment-box" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                            <h3>You're Verified ✅</h3>
                            <p>Click below to complete your payment and unlock the course.</p>
                            <button className="buy-btn" onClick={handlePayment}>Proceed to Payment</button>
                        </motion.div>
                    </div>
                )}
            </div>
        </>
    )
}

export default Buycourse;